import { IScrollLock } from "../typings/modal-scrollLock";

export class ScrollLock implements IScrollLock {
    private static _instance: IScrollLock;

    private constructor() {
    }

    static get instance() {
        return this._instance || (this._instance = new this());
    }

    lock(): void {
        const style = document.body.style;

        /*
            * Use scrollY and pageYOffset due to cross browser compatibility issues
            */
        if (window.scrollY) {
            style.top = '-' + window.scrollY + "px";
        } else {
            style.top = '-' + window.pageYOffset + "px";
        }

        //Add !important here to counter the 'position: relative !important' from ESMF custom-bootstrap. 
        style.setProperty("position", "fixed", "important");
        style.setProperty("left", "0");
        style.setProperty("right", "0");
        style.overflowY = 'scroll';
    };

    unlock(): void {
        const topPosition: number = - parseInt(document.body.style.top);
        const style = document.body.style;

        style.top = '';
        style.position = '';
        style.overflowY = '';

        window.scrollTo(0, topPosition);
    };
}
